import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RelocationCalculator from "@/pages/RelocationCalculator";

export const Route = createFileRoute("/relocation-calculator")({
  head: () => seoHead("/relocation-calculator"),
  component: RelocationCalculator,
});
